// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

const StyledWrapper = styled.div`
  label,
  input {
    font-size: ${props => (props.isMobile ? '14px' : '18px')};
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ guide, handleChange, isMobile }) => (
  <StyledWrapper isMobile={isMobile}>
    <FormGroup controlId='title'>
      <ControlLabel>Title</ControlLabel>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <FormControl type='text' onChange={handleChange} value={guide.title} />
    </FormGroup>
    <FormGroup controlId='text'>
      <ControlLabel>Description</ControlLabel>
      <FormControl
        componentClass='textarea'
        style={{ height: '100px' }}
        onChange={handleChange}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        value={guide.text}
      />
    </FormGroup>
    <FormGroup controlId='popularity'>
      <ControlLabel>Popularity</ControlLabel>
      <FormControl
        componentClass='textarea'
        style={{ height: '100px' }}
        onChange={handleChange}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        value={guide.popularity}
      />
    </FormGroup>
    <FormGroup controlId='dyk'>
      <ControlLabel>Did You Know?</ControlLabel>
      <FormControl
        componentClass='textarea'
        style={{ height: '100px' }}
        onChange={handleChange}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        value={guide.dyk}
      />
    </FormGroup>
  </StyledWrapper>
);
